import React from "react";
import { Controller } from "react-hook-form";

import includes from "lodash/includes";

import Checkbox from "@mui/material/Checkbox";

const CheckboxItemGroupController = ({
  name,
  control,
  rules,
  item,
  ...props
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { value = [], onChange, ...restProps } }) => (
        <Checkbox
          {...restProps}
          checked={includes(value, item.id)}
          onChange={(e) => {
            const newValue = e.target.checked
              ? [...value, item.id]
              : value.filter((id) => id !== item.id);
            onChange(newValue);
          }}
          sx={{
            "&.Mui-checked": {
              color: "var(--red-color)",
            },
          }}
          {...props}
        />
      )}
    />
  );
};

export default CheckboxItemGroupController;
